import React from 'react';

import { LinkButton } from '@eika/button';

import useTranslation from '../hooks/useTranslation';

import './BankIdSigning.scss';

interface Props {
    signUri: string;
    cancelSigningCallback: () => void;
    // @default 'Godkjenn'
    title?: string;
}

const BankIdSigning: React.FC<Props> = ({ signUri, cancelSigningCallback, title }) => {
    const { approve, cancel } = useTranslation();
    return (
        <>
            <h2 className="bank-id-signing__title">{title ?? approve}</h2>
            <div className="bank-id-signing">
                <iframe src={signUri} title="Signering" className="bank-id-signing__iframe" height="325" width="325" />
                <LinkButton onClick={cancelSigningCallback}>{cancel}</LinkButton>
            </div>
        </>
    );
};

export default BankIdSigning;
